import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

import CsLineIcons from "../../cs-line-icons";
import { currentUsage } from "../../utils/api";
import { PlanLock } from "./common";

const NAVIGATION = [
  { to: "/dashboard", label: "Home", end: true, icon: "home" },
  { to: "/dashboard/surveys", label: "Surveys", icon: "clipboard" },
  { to: "/dashboard/results", label: "Results", icon: "chart-4" },
  { to: "/dashboard/invitations", label: "Invitations", icon: "email", paid: true },
  { to: "/dashboard/users", label: "Users", icon: "user" },
  { to: "/dashboard/usage", label: "Usage", icon: "activity" },
  { to: "/dashboard/settings", label: "Settings", icon: "gear" },
];

const FERASURVEY_LOGO_DARK = `${process.env.PUBLIC_URL || ""}/branding/fera/logos/survey/fera-survey-dark.svg`;

function ProductIdentity() {
  return (
    <Link className="fera-logo" to="/dashboard" aria-label="FeraSurvey home">
      <img src={FERASURVEY_LOGO_DARK} alt="FeraSurvey" />
    </Link>
  );
}

function SecureShell({ children }) {
  const [open, setOpen] = useState(false);
  const [usage, setUsage] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    let mounted = true;
    currentUsage()
      .then(result => { if (mounted) setUsage(result); })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  const signOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("instance");
    navigate("/dashboard", { replace: true });
    window.location.reload();
  };
  const paid = Boolean(usage?.features?.invitations);

  return (
    <div className="fera-app-shell">
      <a className="fera-skip-link" href="#fera-main">Skip to main content</a>
      <header className="fera-topbar">
        <ProductIdentity />
        <button
          className="fera-menu-button"
          type="button"
          aria-expanded={open}
          aria-controls="fera-navigation"
          onClick={() => setOpen(value => !value)}
        >
          <span aria-hidden="true">&#9776;</span>
          <span className="visually-hidden">Toggle navigation</span>
        </button>
        <div className="fera-topbar-actions">
          <button type="button" aria-label="Notifications" title="Notifications">
            <CsLineIcons icon="bell" size={19} />
          </button>
          <a href="https://help.feradel.com/survey" target="_blank" rel="noreferrer">Help</a>
          <button type="button" onClick={signOut}>Sign out</button>
        </div>
      </header>
      <div className="fera-workspace">
        <aside id="fera-navigation" className={`fera-sidebar ${open ? "is-open" : ""}`}>
          <nav aria-label="Survey workspace">
            {NAVIGATION.map(item => (
              <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setOpen(false)}>
                <span className="fera-nav-glyph" aria-hidden="true"><CsLineIcons icon={item.icon} size={21} /></span>
                <span>{item.label}</span>
                {item.paid && !paid ? <PlanLock>Paid</PlanLock> : null}
              </NavLink>
            ))}
          </nav>
          <div className="fera-sidebar-foot">Secure surveys and reporting by Feradel</div>
        </aside>
        {open ? <button className="fera-nav-backdrop" aria-label="Close navigation" onClick={() => setOpen(false)} /> : null}
        <main id="fera-main" className="fera-main-content" tabIndex="-1">{children}</main>
      </div>
    </div>
  );
}

export default SecureShell;
